// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
footer[data-v-24246266]
	{
		margin-top: auto;
		padding: 3px 10px 1px 10px;
		width: 100%;
		text-align: center;
		box-sizing: border-box;
		/*background-color: rgba(255,255,255,0.25);*/
		/*box-shadow: 0 0 16px rgba(0,0,0,0.25);*/
		border-top: 1px solid rgba(0,0,0,0.25);
}
`, "",{"version":3,"sources":["webpack://./www/vues/common/Footer.vue"],"names":[],"mappings":";AAiBC;;EAEC,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,yCAAyC;EACzC,sCAAsC;AACvC","sourcesContent":["<template>\r\n\t<footer id=\"appFooter\">TdsAppService {{serverVersion}}</footer>\r\n</template>\r\n\r\n<script>\r\n\r\n\texport default {\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tserverVersion: appContext.serverVersion\r\n\t\t\t};\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\tfooter\r\n\t{\r\n\t\tmargin-top: auto;\r\n\t\tpadding: 3px 10px 1px 10px;\r\n\t\twidth: 100%;\r\n\t\ttext-align: center;\r\n\t\tbox-sizing: border-box;\r\n\t\t/*background-color: rgba(255,255,255,0.25);*/\r\n\t\t/*box-shadow: 0 0 16px rgba(0,0,0,0.25);*/\r\n\t\tborder-top: 1px solid rgba(0,0,0,0.25);\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
